import { jsxs as h, jsx as d } from "react/jsx-runtime";
import { forwardRef as b, useState as v } from "react";
import { c as p } from "./tw-cn-mXgPecoF.mjs";
import { ERROR_IMAGE_URL as x } from "./utils.es.js";
import { e as s } from "./extract-responsive-property-BiJ5BiwI.mjs";
import { c as E } from "./index-BpNK5r1N.mjs";
const S = E(["relative overflow-hidden"], {
  variants: {
    ratio: {
      "3_4": "aspect-[3/4]",
      "2_3": "aspect-[2/3]",
      "1_1": "aspect-[1/1]",
      "2_1": "aspect-[2/1]",
      "3_2": "aspect-[3/2]",
      "6_5": "aspect-[6/5]"
    },
    shape: {
      roundedRectangle_8: "rounded-8",
      roundedRectangle_12: "rounded-12",
      roundedRectangle_16: "rounded-16",
      roundedRectangle_20: "rounded-20",
      capsule: "rounded-capsule",
      rectangle: "",
      asymmetric_12_12_0_0: "rounded-t-12"
    },
    pcRatio: {
      "3_4": "pc:aspect-[3/4]",
      "2_3": "pc:aspect-[2/3]",
      "1_1": "pc:aspect-[1/1]",
      "2_1": "pc:aspect-[2/1]",
      "3_2": "pc:aspect-[3/2]",
      "6_5": "pc:aspect-[6/5]"
    },
    pcShape: {
      roundedRectangle_8: "pc:rounded-8",
      roundedRectangle_12: "pc:rounded-12",
      roundedRectangle_16: "pc:rounded-16",
      roundedRectangle_20: "pc:rounded-20",
      capsule: "pc:rounded-capsule",
      rectangle: "",
      asymmetric_12_12_0_0: "pc:rounded-t-12"
    }
  }
}), j = ({ alt: r, className: t, src: e, loading: c, onError: o }) => /* @__PURE__ */ d("img", { alt: r, className: t, loading: c, onError: o, src: e }), I = b(
  ({ shape: r, ratio: t, image: e, alt: c, className: o, imgClassName: u, imageComponent: l, loading: m, children: i, width: a, ..._ }, R) => {
    const [n, g] = v(!e), y = l ?? j, f = S({
      ...s({
        property: r,
        mobileKey: "shape",
        pcKey: "pcShape"
      }),
      ...s({
        property: t,
        mobileKey: "ratio",
        pcKey: "pcRatio"
      })
    });
    return /* @__PURE__ */ h(
      "div",
      {
        className: p(f, o),
        ref: R,
        style: { width: a ? `${a / 10}rem` : void 0 },
        ..._,
        children: [
          /* @__PURE__ */ d(
            y,
            {
              alt: c ?? "Thumbnail",
              className: p("mx-auto size-full bg-fill-neutral-weak1 object-center", u, {
                "object-cover": !n
              }),
              loading: m,
              onError: () => {
                g(!0);
              },
              src: n ? x : e
            }
          ),
          i
        ]
      }
    );
  }
);
I.displayName = "NDS.Thumbnail";
export {
  I as T
};
